export class SHType<T> {
    private readonly types: Map<T, string>;
    private readonly label: string;

    constructor(label: string, typeItems: [T, string][]) {
        this.types = new Map(typeItems);
        this.label = label;
    }

    getName(id: T): string {
        const name = this.types.get(id);
        if (name) {
            return name;
        } else {
            throw Error(`Unsupported appStateTypeId: ${id}`);
        }
    }
}